export class WorldInfo {

    descriptions:Array<string> = [];

    xml:Element;

    constructor(public code:string, public index:number) {

    }

    importXML(_xml:Element):void {
        this.xml = _xml;
        let descs = _xml.getElementsByTagName('description');
        for(let i = 0; i < descs.length; ++i) {
            this.descriptions.push(descs[i].textContent);
        }
    }

    getLevelXML(index:number):Element {
        let levels = this.xml.getElementsByTagName('level');
        for(let i=0;i<levels.length;++i) {
            let lvxml = levels[i];
            if(lvxml.getAttribute('level') == '' + index) {
                return lvxml;
            }
        }
        return null;
    }
}


export const WorldList:Array<WorldInfo> = [];

export function importWorldXML(xml:XMLDocument):void {
    let xmls = xml.getElementsByTagName('world');
    for(let i = 0; i < xmls.length; ++i) {
        let worldxml = xmls[i];
        let info:WorldInfo = new WorldInfo(worldxml.getAttribute('code'), WorldList.length);
        info.importXML(worldxml);
        WorldList.push(info);
    }
}

export function getWorld(code:string):WorldInfo {

    for(let world of WorldList) {
        if(world.code == code) {
            return world;
        }
    }
    return null;
}


// WEBPACK FOOTER //
// ./src/data/WorldInfo.ts